import React from 'react';
import PropTypes from 'prop-types';

import DesignatedRaterDashboard from './DesignatedRaterDashboard';
import { ReportBarChartSection } from './ReportBarChartSection';
import { ReportCaptionSection } from './ReportCaptionSection';
import { ReportConflictChartSection } from './ReportConflictChartSection';
import { ReportConsentSection } from './ReportConsentSection';
import { ReportDebriefSection } from './ReportDebriefSection';
import { ReportDiscussionSection } from './ReportDiscussionSection';
import { ReportLeadershipChartSection } from './ReportLeadershipChartSection';
import { ReportPeerFeedbackExpressSection } from './ReportPeerFeedbackExpressSection';
import { ReportPeerFeedbackMedianSection } from './ReportPeerFeedbackMedianSection';
import { ReportPersonalityChartSection } from './ReportPersonalityChartSection';
import { ReportTeamDynamicsChartSection } from './ReportTeamDynamicsChartSection';
import { ReportTeamPersonalityChartSection } from './ReportTeamPersonalityChartSection';
// v6.2 (2026-05-23 pm): teamPlayer minimal real report section, mapped to
// section.type 'teamPlayerSummary' which the server's reportSections
// registry produces for the teamPlayer template.
import { ReportTeamPlayerSummarySection } from './ReportTeamPlayerSummarySection';
import { ReportTitleSection } from './ReportTitleSection';

const typeComponentMap = {
  caption: ReportCaptionSection,
  personalityReport: ReportPersonalityChartSection,
  teamPersonalityReport: ReportTeamPersonalityChartSection,
  teamDynamicsReport: ReportTeamDynamicsChartSection,
  conflictReport: ReportConflictChartSection,
  reportChart: ReportBarChartSection,
  debrief: ReportDebriefSection,
  discussion: ReportDiscussionSection,
  peerFeedbackExpress: ReportPeerFeedbackExpressSection,
  peerFeedbackMedian: ReportPeerFeedbackMedianSection,
  consentOptIn: ReportConsentSection,
  leadershipReport: ReportLeadershipChartSection,
  teamPlayerSummary: ReportTeamPlayerSummarySection,
};

function ReportBody({
  reportSections, respondent, updateResponse, templateMode, disableReportResponse,
}) {
  if (!respondent.report) {
    return null;
  }
  return (
    <>
      <DesignatedRaterDashboard respondent={respondent} />
      <ReportTitleSection respondent={respondent} templateMode={templateMode} />
      {(reportSections || []).map((section) => {
        const key = `report-section-${section.type}-${section.key}`;
        const MappedComponent = typeComponentMap[section.type];
        if (MappedComponent) {
          return (
            <MappedComponent
              key={key}
              respondent={respondent}
              section={section}
              updateResponse={updateResponse}
              disableReportResponse={disableReportResponse}
            />
          );
        }
        return null;
      })}
    </>
  );
}

ReportBody.propTypes = {
  reportSections: PropTypes.array,
  respondent: PropTypes.shape({
    createdAt: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    response: PropTypes.object,
    report: PropTypes.object,
    reportResponse: PropTypes.object,
    status: PropTypes.string,
    surveyId: PropTypes.string,
    templateId: PropTypes.string,
    updatedAt: PropTypes.string,
    respondentId: PropTypes.string,
  }),
  updateResponse: PropTypes.func,
  templateMode: PropTypes.bool,
  disableReportResponse: PropTypes.bool,
};

ReportBody.defaultProps = {
  reportSections: null,
  respondent: { report: null },
  updateResponse: () => {},
  templateMode: false,
  disableReportResponse: false,
};

export default ReportBody;
